import { useRef } from "react";
import axios from "axios";
import { getSessionCompanies } from "utils/session";
import { MXF_NEST_API_URL } from "./useMxfApiNest";

const BASE_URL = `${MXF_NEST_API_URL}/integracao-mxf`;

export const useAPILinkMix = () => {
  const apiRef = useRef(axios.create({ baseURL: BASE_URL }));

  apiRef.current.interceptors.request.use(config => {
    config.headers["Authorization"] = `Bearer ${getSessionCompanies()}`;
    return config;
  });

  // TODO: Adicionar toast automatico quando as requisições falharem!
  apiRef.current.interceptors.response.use(
    response => response,
    error => {
      // console.log(error.response);
      return Promise.reject(error);
    },
  );

  return apiRef.current;
};
